// Icons from several packs across FlatIcon, Isoflow.
// All icons from every pack are included in this file but some are commented out if they're unsuitable.

// Digital Wallet Icons (Pack: fi-12725749-digital-wallet)
import DigitalWallet001Person from "./fi-12725749-digital-wallet/001-person.svg";
// import DigitalWallet002Computer from "./fi-12725749-digital-wallet/002-computer.svg";
import DigitalWallet003Computer from "./fi-12725749-digital-wallet/003-computer.svg";
import DigitalWallet004Money from "./fi-12725749-digital-wallet/004-money.svg";
import DigitalWallet005Computer from "./fi-12725749-digital-wallet/005-computer.svg";
import DigitalWallet006Business from "./fi-12725749-digital-wallet/006-business.svg";
import DigitalWallet007Music from "./fi-12725749-digital-wallet/007-music.svg";
import DigitalWallet008Computer from "./fi-12725749-digital-wallet/008-computer.svg";
import DigitalWallet009Computer from "./fi-12725749-digital-wallet/009-computer.svg";
import DigitalWallet010Technology from "./fi-12725749-digital-wallet/010-technology.svg";
import DigitalWallet011Check from "./fi-12725749-digital-wallet/011-check.svg";
import DigitalWallet012Internet from "./fi-12725749-digital-wallet/012-internet.svg";
import DigitalWallet013Silhouette from "./fi-12725749-digital-wallet/013-silhouette.svg";
import DigitalWallet014Silhouette from "./fi-12725749-digital-wallet/014-silhouette.svg";
import DigitalWallet015Computer from "./fi-12725749-digital-wallet/015-computer.svg";
import DigitalWallet016Money from "./fi-12725749-digital-wallet/016-money.svg";

// Storage Icons (Pack: fi-12736188-storage)
// import Storage001Paper from "./fi-12736188-storage/001-paper.svg";
import Storage002Music from "./fi-12736188-storage/002-music.svg";
import Storage003Business from "./fi-12736188-storage/003-business.svg";
import Storage004Upload from "./fi-12736188-storage/004-upload.svg";
import Storage005Computer from "./fi-12736188-storage/005-computer.svg";
// import Storage006Man from "./fi-12736188-storage/006-man.svg";
import Storage007Computer from "./fi-12736188-storage/007-computer.svg";
import Storage008Computer from "./fi-12736188-storage/008-computer.svg";
import Storage009Music from "./fi-12736188-storage/009-music.svg";
import Storage010Car from "./fi-12736188-storage/010-car.svg";
import Storage011Flash from "./fi-12736188-storage/011-flash.svg";
import Storage012Music from "./fi-12736188-storage/012-music.svg";
import Storage013Computer from "./fi-12736188-storage/013-computer.svg";
import Storage014Computer from "./fi-12736188-storage/014-computer.svg";
import Storage015Book from "./fi-12736188-storage/015-book.svg";
import Storage016Globe from "./fi-12736188-storage/016-globe.svg";
import Storage017Computer from "./fi-12736188-storage/017-computer.svg";
import Storage018Computer from "./fi-12736188-storage/018-computer.svg";

// Isoflow Icons (Pack: isoflow)
import IsoflowBlock from "./isoflow/block.svg";
import IsoflowCache from "./isoflow/cache.svg";
import IsoflowCardterminal from "./isoflow/cardterminal.svg";
import IsoflowCloud from "./isoflow/cloud.svg";
import IsoflowCronjob from "./isoflow/cronjob.svg";
import IsoflowCube from "./isoflow/cube.svg";
import IsoflowDesktop from "./isoflow/desktop.svg";
import IsoflowDiamond from "./isoflow/diamond.svg";
import IsoflowDns from "./isoflow/dns.svg";
import IsoflowDocument from "./isoflow/document.svg";
import IsoflowFirewall from "./isoflow/firewall.svg";
import IsoflowFunctionModule from "./isoflow/function-module.svg";
import IsoflowImage from "./isoflow/image.svg";
import IsoflowLaptop from "./isoflow/laptop.svg";
import IsoflowLoadbalancer from "./isoflow/loadbalancer.svg";
import IsoflowLock from "./isoflow/lock.svg";
import IsoflowMail from "./isoflow/mail.svg";
import IsoflowMailmultiple from "./isoflow/mailmultiple.svg";
import IsoflowMobiledevice from "./isoflow/mobiledevice.svg";
import IsoflowOffice from "./isoflow/office.svg";
import IsoflowPackageModule from "./isoflow/package-module.svg";
import IsoflowPaymentcard from "./isoflow/paymentcard.svg";
import IsoflowPlane from "./isoflow/plane.svg";
import IsoflowPrinter from "./isoflow/printer.svg";
import IsoflowPyramid from "./isoflow/pyramid.svg";
import IsoflowQueue from "./isoflow/queue.svg";
import IsoflowRouter from "./isoflow/router.svg";
import IsoflowServer from "./isoflow/server.svg";
import IsoflowSpeech from "./isoflow/speech.svg";
import IsoflowSphere from "./isoflow/sphere.svg";
import IsoflowStorage from "./isoflow/storage.svg";
import IsoflowSwitchModule from "./isoflow/switch-module.svg";
import IsoflowTower from "./isoflow/tower.svg";
import IsoflowTruck2 from "./isoflow/truck-2.svg";
import IsoflowTruck from "./isoflow/truck.svg";
import IsoflowUser from "./isoflow/user.svg";
import IsoflowVm from "./isoflow/vm.svg";

export type IconPack = {id: string; label: string; icons: IconInfo[]};

export type IconInfo = {id: string; label: string; url: string};

export const ICON_PACKS: IconPack[] = [
  {
    id: "fi.digital-wallet",
    label: "Digital wallet",
    icons: [
      {id: "fi.digital-wallet.001.person", label: "Wallet", url: DigitalWallet001Person},
      // {id: "fi.digital-wallet.002.computer", label: "Wallet (large)", url: DigitalWallet002Computer},
      {id: "fi.digital-wallet.003.computer", label: "Terminal", url: DigitalWallet003Computer},
      {id: "fi.digital-wallet.004.money", label: "Dollar sign", url: DigitalWallet004Money},
      {id: "fi.digital-wallet.005.computer", label: "WiFi", url: DigitalWallet005Computer},
      {id: "fi.digital-wallet.006.business", label: "QR Code", url: DigitalWallet006Business},
      {id: "fi.digital-wallet.007.music", label: "Terminal", url: DigitalWallet007Music},
      {id: "fi.digital-wallet.008.computer", label: "Cog", url: DigitalWallet008Computer},
      {id: "fi.digital-wallet.009.computer", label: "Cloud", url: DigitalWallet009Computer},
      {id: "fi.digital-wallet.010.technology", label: "Globe", url: DigitalWallet010Technology},
      {id: "fi.digital-wallet.011.check", label: "Check", url: DigitalWallet011Check},
      {id: "fi.digital-wallet.012.internet", label: "Envelope", url: DigitalWallet012Internet},
      {id: "fi.digital-wallet.013.silhouette", label: "Payment card", url: DigitalWallet013Silhouette},
      {id: "fi.digital-wallet.014.silhouette", label: "Coin", url: DigitalWallet014Silhouette},
      {id: "fi.digital-wallet.015.computer", label: "Laptop", url: DigitalWallet015Computer},
      {id: "fi.digital-wallet.016.money", label: "Money", url: DigitalWallet016Money},
    ],
  },
  {
    id: "fi.storage",
    label: "Storage",
    icons: [
      // {id: "fi.storage.001.paper", label: "Box (open)", url: Storage001Paper},
      {id: "fi.storage.002.music", label: "Laptop", url: Storage002Music},
      {id: "fi.storage.003.business", label: "Box", url: Storage003Business},
      {id: "fi.storage.004.upload", label: "Upload", url: Storage004Upload},
      {id: "fi.storage.005.computer", label: "Desktop computer", url: Storage005Computer},
      // {id: "fi.storage.006.man", label: "Watch", url: Storage006Man},
      {id: "fi.storage.007.computer", label: "Computer", url: Storage007Computer},
      {id: "fi.storage.008.computer", label: "Chip", url: Storage008Computer},
      {id: "fi.storage.009.music", label: "Terminal", url: Storage009Music},
      {id: "fi.storage.010.car", label: "Building", url: Storage010Car},
      {id: "fi.storage.011.flash", label: "Flash drive", url: Storage011Flash},
      {id: "fi.storage.012.music", label: "Memory card", url: Storage012Music},
      {id: "fi.storage.013.computer", label: "Server rack", url: Storage013Computer},
      {id: "fi.storage.014.computer", label: "Server (small)", url: Storage014Computer},
      {id: "fi.storage.015.book", label: "Filing cabinet", url: Storage015Book},
      {id: "fi.storage.016.globe", label: "Storage", url: Storage016Globe},
      {id: "fi.storage.017.computer", label: "Cylinders", url: Storage017Computer},
      {id: "fi.storage.018.computer", label: "Server rack", url: Storage018Computer},
    ],
  },
  {
    id: "isoflow",
    label: "Isoflow",
    icons: [
      {id: "isoflow.block", label: "Block", url: IsoflowBlock},
      {id: "isoflow.cache", label: "Cache", url: IsoflowCache},
      {id: "isoflow.cardterminal", label: "Card Terminal", url: IsoflowCardterminal},
      {id: "isoflow.cloud", label: "Cloud", url: IsoflowCloud},
      {id: "isoflow.cronjob", label: "Cron Job", url: IsoflowCronjob},
      {id: "isoflow.cube", label: "Cube", url: IsoflowCube},
      {id: "isoflow.desktop", label: "Desktop", url: IsoflowDesktop},
      {id: "isoflow.diamond", label: "Diamond", url: IsoflowDiamond},
      {id: "isoflow.dns", label: "DNS", url: IsoflowDns},
      {id: "isoflow.document", label: "Document", url: IsoflowDocument},
      {id: "isoflow.firewall", label: "Firewall", url: IsoflowFirewall},
      {id: "isoflow.function-module", label: "Function Module", url: IsoflowFunctionModule},
      {id: "isoflow.image", label: "Image", url: IsoflowImage},
      {id: "isoflow.laptop", label: "Laptop", url: IsoflowLaptop},
      {id: "isoflow.loadbalancer", label: "Load Balancer", url: IsoflowLoadbalancer},
      {id: "isoflow.lock", label: "Lock", url: IsoflowLock},
      {id: "isoflow.mail", label: "Mail", url: IsoflowMail},
      {id: "isoflow.mailmultiple", label: "Mail Multiple", url: IsoflowMailmultiple},
      {id: "isoflow.mobiledevice", label: "Mobile Device", url: IsoflowMobiledevice},
      {id: "isoflow.office", label: "Office", url: IsoflowOffice},
      {id: "isoflow.package-module", label: "Package Module", url: IsoflowPackageModule},
      {id: "isoflow.paymentcard", label: "Payment Card", url: IsoflowPaymentcard},
      {id: "isoflow.plane", label: "Plane", url: IsoflowPlane},
      {id: "isoflow.printer", label: "Printer", url: IsoflowPrinter},
      {id: "isoflow.pyramid", label: "Pyramid", url: IsoflowPyramid},
      {id: "isoflow.queue", label: "Queue", url: IsoflowQueue},
      {id: "isoflow.router", label: "Router", url: IsoflowRouter},
      {id: "isoflow.server", label: "Server", url: IsoflowServer},
      {id: "isoflow.speech", label: "Speech", url: IsoflowSpeech},
      {id: "isoflow.sphere", label: "Sphere", url: IsoflowSphere},
      {id: "isoflow.storage", label: "Storage", url: IsoflowStorage},
      {id: "isoflow.switch-module", label: "Switch Module", url: IsoflowSwitchModule},
      {id: "isoflow.tower", label: "Tower", url: IsoflowTower},
      {id: "isoflow.truck-2", label: "Truck 2", url: IsoflowTruck2},
      {id: "isoflow.truck", label: "Truck", url: IsoflowTruck},
      {id: "isoflow.user", label: "User", url: IsoflowUser},
      {id: "isoflow.vm", label: "VM", url: IsoflowVm},
    ],
  },
] as const satisfies IconPack[];

const DEFAULT_ICON_ID = "isoflow.block" satisfies (typeof ICON_PACKS)[number]["icons"][number]["id"];

// Icon lookup by ID
const ICONS = new Map<string, IconInfo>(ICON_PACKS.flatMap<IconInfo>(pack => pack.icons).map(icon => [icon.id, icon]));

export function getIcon(id: string): IconInfo {
  const icon = ICONS.get(id);

  if (icon == null) {
    console.warn(`Icon with id ${id} not found`);
    return getDefaultIcon();
  }

  return icon;
}

export function getDefaultIcon(): IconInfo {
  return ICONS.get(DEFAULT_ICON_ID)!;
}
